import React from 'react';

function Description(props) {
    return (
        <section className="container">
            <div className="has-text-centered content">
                <br/>
                {/* <h1 className="title is-4 is-uppercase has-text-danger">WETC</h1> */}
                <h2 className="title is-6 has-text-primary">Simple Way To Wrap/UnWrap WETC</h2>
            </div>
        </section>
    )
}

export default Description;
    


// WEBPACK FOOTER //
// ./src/Components/Description.js